import EmailIcon from '@atlaskit/icon/core/email';
import * as React from 'react';

export function SvgWriteMessage() {
  return <EmailIcon label="" testId="ads-refreshed-icon" />;
}
